export default {
  title: "按需付费",
  subtitle: "根据需要购买积分，无需订阅",
  calculation_title: "碳排放计算",
  report_title: "报告",
  combo_title: "组合套餐",
  combo_subtitle: "通过我们的组合套餐节省更多",
  select_quantity: "选择数量",
  select_package: "选择套餐",
  total: "总计",
  calculation_credits: "计算积分",
  report_credits: "报告积分",
  credits: "积分",
  price: "价格",
  buy_now: "立即购买",
  starter_pack: "入门套餐",
  professional_pack: "专业套餐",
  enterprise_pack: "企业套餐",
  save_x_percent: "节省 {percent}%",
  note: "您购买的积分永不过期。",
  expiry_note: "您可以随时使用它们。未来将提供可选的积分延期或转换功能。",
  calculation_price: "碳排放计算",
  report_price: "报告",
  calculation_price_dynamic: "每次计算 {price}",
  report_price_dynamic: "每份报告 {price}",
  benefits: "按需付费优势",
  future_features: "即将推出的功能",
  future_features_desc: "我们计划稍后引入可选的积分延期和兑换功能。现在无需操作。",
  extension_option_future: "积分延期",
  extension_option_future_desc: "小额费用延长您的积分有效期（将在未来版本中提供）。",
  credit_exchange_future: "积分兑换",
  credit_exchange_future_desc: "将未使用或过期的积分兑换为未来版本的试用访问权限。",
  quantity: "数量",
  ladder_pricing: "阶梯定价",
  unit: "单位",
  pay_per_use_benefit1: "无需订阅",
  pay_per_use_benefit2: "只为所用付费",
  pay_per_use_benefit3: "永久有效",
};
